import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Boot watchdog iz index.html: done() skida splash dijagnostiku, fail() je odmah prikaže
// (bez ovoga pucanje bootstrap-a ostaje samo u konzoli, a ekran zauvek na splash-u).
const bootWatchdog = (window as any).emeniBoot;

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => bootWatchdog?.done())
  .catch(err => {
    console.error(err);
    bootWatchdog?.fail(err);
  });
